const NavSeparator = () => {
  return <div className="h-5 w-px bg-border mx-2" />;
};

export default NavSeparator;
